export enum EmailMenuContent {
  Notes,
  Notifications,
  Templates,
  Audit,
  Tags,
}

export enum EmailClass {
  Email = 1,
  Notification = 2,
}
